import { timestamp } from "../../lib/dateHelper";
import { createRecord, findRecordById, listRecords } from "../../server/fetchFunctions";

type ObjectT = { [key: string]: any };

export const saveJob = async (
  e: React.FormEvent<HTMLFormElement>,
  job: ObjectT,
  device: ObjectT,
  clientDevice: ObjectT
) => {
  e.preventDefault();
  try {
    let newClient;
    let newContact;
    let newDevice;
    let newClientDevice;

    //Create client if not exist
    if (!job.client_id) {
      newClient = await createRecord("clients", {
        name: job.client_name,
        vat: job.client_vat,
        zip: job.client_zip,
        city: job.client_city,
        street: job.client_street,
      });
    }

    //Create contact if not exist
    if (!job.contact_id) {
      newContact = await createRecord("contacts", {
        name: job.contact_name,
        phone: job.contact_phone,
        email: job.contact_email,
        client_id: job.client_id ? job.client_id : newClient.id,
      });
    }

    if (!device.id && !device.description_id) {
      alert("Eszköz megnevezése nem található az adatbázisban. Új eztközt az Eszközök fülön hozhat létre");
      return;
    }

    if (!device.id && !device.manufacturer_id) {
      alert("Gyártó nem található az adatbázisban. Új eztközt az Eszközök fülön hozhat létre.");
      return;
    }

    //Add device if not exist
    if (!device.id) {
      newDevice = await createRecord("devices", {
        type: device.type,
        description_id: device.description_id,
        manufacturer_id: device.manufacturer_id,
        cal_price: device.cal_price,
      });
    }

    //Add client device if not exist
    if (!clientDevice.id) {
      newClientDevice = await createRecord("clientDevices", {
        client_id: job.client_id ? job.client_id : newClient.id,
        device_id: device.id ? device.id : newDevice.id,
        serial_no: clientDevice.serial_no,
      });
    }

    //Create Job
    const statusId = await listRecords("status", { status_name: "Átvett" });
    const jobnumber = await findRecordById("getNextNumber", "jobnumber");
    const calnumber = job.calibration === 1 ? await findRecordById("getNextNumber", "calnumber") : null;
    const newJob = await createRecord("jobs", {
      ...job,
      date: job.date ? job.date : null,
      promise_date: job.promise_date ? job.promise_date : null,
      job_number: jobnumber.next_number,
      cal_number: job.calibration === 1 ? calnumber.next_number : null,
      client_id: job.client_id ? job.client_id : newClient.id,
      contact_id: job.contact_id ? job.contact_id : newContact.id,
      device_id: clientDevice.id ? clientDevice.id : newClientDevice.id,
      status_id: statusId.data[0].id,
    });

    //Set timeline
    await createRecord("timeline", {
      job_id: newJob.id,
      note: "Munka létrehozva",
      status_id: newJob.status_id,
      timestamp: timestamp(),
    });
    window.location.href = `/jobs/${newJob.id}`;
  } catch (error) {
    alert(error);
  }
};
